window.addEventListener('SITE_START', () => {
  function animsInit(target = '') {
    // target에 따라 실행 시점 분기 — data-anims / data-anims-2,3,4 ...
    const selector = target ? `[data-anims-${target}]` : '[data-anims]';

    document.querySelectorAll(selector).forEach((anims) => {
      const animsDelay = anims.getAttribute('data-anims-delay') ? parseFloat(anims.getAttribute('data-anims-delay')) : 0;
      const animsStart = anims.getAttribute('data-anims-start') ? anims.getAttribute('data-anims-start') : '80%';
      anims.querySelectorAll(`[data-anim${target ? '-' + target : ''}]`).forEach((anim) => {
        const animType = anim.getAttribute('data-anim');
        if (animType === 'char') {
          anim.st = new SplitText(anim, { type: 'chars, words, lines', charsClass: '__char', wordsClass: '__word', linesClass: '__line' });
          gsap.set(anim.st.chars, { yPercent: 120 });
        } else  if (animType === 'word') {
          anim.st = new SplitText(anim, { type: 'chars, words, lines', charsClass: '__char', wordsClass: '__word', linesClass: '__line' });
          gsap.set(anim.st.words, { yPercent: 120 });
        } else if (animType === 'img') {
          gsap.set(anim, { scale: 1.4, opacity: 0 });
        }
        else {
          gsap.set(anim, { y: '6rem', opacity: 0 });
        }
      });
  
      ScrollTrigger.create({
        trigger: anims,
        start: `top ${animsStart}`,
        end: 'top top',
        onEnter: () => {
          anims.querySelectorAll(`[data-anim${target ? '-' + target : ''}]`).forEach((anim, i) => {
            const animType = anim.getAttribute(`data-anim${target ? '-' + target : ''}`);
            if (animType === 'char') {
              gsap.set(anim, {opacity: 1});
              gsap.to(anim.st.chars, { yPercent: 0, opacity: 1, ease: Quint.easeOut, duration: 1.2, stagger: 0.025, delay: animsDelay + i * 0.25 });
            } else if (animType === 'word') {
              gsap.set(anim, {opacity: 1});
              gsap.to(anim.st.words, { yPercent: 0, opacity: 1, ease: Quint.easeOut, duration: 1.2, stagger: 0.08, delay: animsDelay + i * 0.25 });
            } else if (animType === 'img') {
              gsap.to(anim, { scale: 1, opacity: 1, ease: Quint.easeOut, duration: 2, delay: animsDelay + i * 0.25 });
            } else {
              gsap.to(anim, { y: 0, opacity: 1, ease: Quint.easeOut, duration: 1.6, delay: animsDelay + i * 0.25 });
            }
          });
        }
      })
  
    });
  }
  window.animsInit = animsInit;
  animsInit();
})